module.exports = __webpack_public_path__ + "static/media/place_students_start_placing_screen.1cb38f63.png";